/**
 * @author czy
 * 功能：汇率
 */

import { Service } from '@/tools'

export class ExChangeRateService<T extends TCommodity.ExChangeRate> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.ExChangeRate}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询所有货币汇率
  // /api/commodity/exchangeRate/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // 新增汇率 /api/commodity/exchangeRate/v1/insert
  insert = <K extends T['ApiInsert']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInsert', data)

  // 汇率更新  /api/commodity/exchangeRate/v1/updateById
  updateById = <K extends T['ApiUpdateById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateById', data)

  // 汇率删除 /api/commodity/exchangeRate/v1/deleteById
  deleteById = <K extends T['ApiDeleteById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteById', data)
  //根据条件汇率/api/commodity/exchangeRate/v1/findListByCondition
  findListByCondition = <K extends T['ApiFindListByCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFindListByCondition', data)

  // findListByCondition = <K extends T['ApiFindListByCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFindListByCondition', {})
}
